import type { IAppFeature } from './app-feature'
import type { DeviceType } from './device-type'
import type { IPurchase } from '~/types/app-purchase'

export enum APP_USER_STATUS {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  PENDING_DELETION = 'pending_deletion',
}

export enum USER_TYPE {
  DEV = 'dev',
  PROD = 'prod',
}

export interface IAppUserRequest {
  dev_users: IAppUser[] | null
  prod_users: IAppUser[] | null
}

export interface IConnection {
  active: boolean
  app_key: string
  connection_id: string
  country: string
  created_at: number
  device_language: string
  device_type: DeviceType
  installation_id: string
  last_seen: number
  updated_at: number
}

export interface IConnectionCode {
  code: string
  code_type: string
  created_at: number
  updated_at: number
  used_at: number | null
}

export interface IEmailCredentials {
  client_id: string
  connection_codes: IConnectionCode[] | null
  created_at: number
  email: string
  is_verified: boolean
  updated_at: number
  user_id: string
}

export interface IProviderCredentials {
  created_at: number
  data: {
    'access-token': string
    'app-key': string
    'client-id': string
    'device-language': string
    'device-type': DeviceType
    exp: number
    id: string
    'installation-id': string
    'redirect-url': string
  }
  provider: string
  provider_user_id: string
  updated_at: number
}

export interface IAppUser {
  client_id: string
  connections: IConnection[] | null
  created_at: number
  email_credentials: IEmailCredentials[] | null
  features: IAppFeature
  last_seen: number
  provider_credentials: IProviderCredentials[] | null
  purchases: IPurchase[] | null
  status: APP_USER_STATUS
  updated_at: number
  user_id: string
}

export interface IResendAppsUserVerificationMailPayload {
  appKey: string
  deviceType: string
  email: string
  env: USER_TYPE
  userId: string
}

export interface IConnectionData {
  appKey: string
  connectionId: string
  deviceLanguage: string
  deviceType: DeviceType
  installationId: string
}
